import { render } from "./leftHall.html?vue&type=template&id=090268ec"
import script from "./LeftHall.vue?vue&type=script&lang=ts"
export * from "./LeftHall.vue?vue&type=script&lang=ts"
script.render = render

export default script